import axios from 'axios';

export const getIp = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_IP_ENDPOINT);
        if (response.data.ip)
            return response.data.ip;
        else
            throw new Error("Error getting the IP address");

    } catch (error) {
        return { isError: true, message: error.message };
    }
}